export default __webpack_public_path__ + "static/media/lens.77cfd6ee.svg";